import createTaskService from '../services/createTaskService';
import Todo from '../store/schema/Todo';

/**
 * Handles creating multiple todos.
 * We need this because the REST API doesn't support creating multiple tasks in a single request.
 * This method returns after all the create calls are done.
 *
 * @param todos The todos to create
 * @param folderId The folder id in which to create the todos. If null, todos are created in default folder.
 */
export default async function handleCreateTodos(todos: Todo[], folderId: string): Promise<void> {
    const createPromises: Promise<boolean>[] = [];

    todos.forEach(todo => {
        createPromises.push(createTaskService(todo, folderId));
    });

    await Promise.all<Promise<boolean>>(createPromises);
}
